import Component from '../core/Component'
import Cookies from 'js-cookie'
import { EMITS as MODAL_EMITS } from './Modal'

export default class BookingReminder extends Component {
    constructor(element, options = {}) {
        super(element, options)

        this.ref = {
            modal: null
        }

        this.canShow = true
        this.isActive = false
        this.timeout = null
    }

    prepare() {
        const modalId = this.element.dataset.target

        this.modal = Component.getFromElement(modalId)
        if (!this.modal) {
            return
        }

        this.modal.on(MODAL_EMITS.CLOSE, this.handleModalClose)

        this.canShow = Cookies.get('bookingReminderShown') !== 'true'

        if (this.canShow) {
            this.timeout = setTimeout(() => {
                this.attach()
                this.timeout = null
            }, 7000)
        }
    }

    destroy() {
        if (this.timeout) {
            clearTimeout(this.timeout)
        }
        this.detach()
    }

    attach() {
        document.documentElement.addEventListener('mouseleave', this.handleMouseLeave)
    }

    detach() {
        document.documentElement.removeEventListener('mouseleave', this.handleMouseLeave)
    }

    handleMouseLeave = () => {
        if (this.isActive) {
            return
        }

        this.modal.open()
        this.isActive = true
    }

    handleModalClose = () => {
        Cookies.set('bookingReminderShown', true, {
            expires: 1
        })

        this.detach()
    }
}